module.exports = __webpack_public_path__ + "static/media/vscode.a78dfa30.png";